import { searchParam } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { PartLibrarySearchPage } from '@/areas/parts/PartLibrarySearchPage/PartLibrarySearchPage';
import { partLibrarySearchTabs } from '@/areas/parts/PartLibrarySearchPage/partLibrarySearchTabs';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/_sidebar/search')({
    // Customer users hold part library access for the stock information in the BOM, so the library itself is
    // Internal-only.
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: z.object({
        tab: searchParam.enum(partLibrarySearchTabs, 'optional'),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const tab = Route.useSearch({ select: (search) => search.tab });
    return <PartLibrarySearchPage tab={tab} />;
}
